import * as service from './service'
import { HTTP_CODE } from '@/utils/request'
export default {
  namespace: 'acceleratorCardBuyRecordList',
  state: {
    demoData: {}
  },
  effects: {
    * getData ({ payload }, { call, put }) {
      try {
        const res = yield call(service.list, payload)
        if (res.data.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        }
        return res.data
      } catch (err) {
        console.log(err, 'errrrrrr')
        return err
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
